// ABOUTME: The footer mic button's tap and its shown state, out of App.js (review 2026-10-08): flag-off it is exactly the old toggle;
// ABOUTME: under mic_voice_control the icon follows the LIVE capture and the tap means "turn voice on" whenever nothing is captured.

/**
 * Pure builder (no hooks): App calls it every render with its current facts.
 *
 * @param {object} p
 * @param {boolean} p.enabled ux.mic_voice_control
 * @param {{isWaiting: Function, tap: Function}} p.landing useLanding() (no_enter_gate)
 * @param {{current: boolean}} p.hasAudioConsentRef App's imperative consent guard
 * @param {boolean} p.hasAudioConsent
 * @param {boolean} p.needsDecision the consent record is missing or stale
 * @param {boolean} p.isMicOn the guest's wish
 * @param {Function} p.setIsMicOn
 * @param {{live: boolean, blocked: (null|string), markRetry: Function}} p.micBlocked useMicBlocked()
 * @param {Function} p.startMicrophone
 * @param {Function} p.enableVoice records voice consent and starts the mic (in the boutique)
 * @param {Function} p.enterWithVoice records voice consent and enters (on the landing)
 * @param {Function} p.openPrivacy the flag-off no-consent route
 * @returns {{ onToggleMic: Function, micShownOn: boolean, micRecording: boolean }}
 */
export function micVoiceToggle({
  enabled, landing, hasAudioConsentRef, hasAudioConsent, needsDecision, isMicOn, setIsMicOn, micBlocked, startMicrophone,
  enableVoice, enterWithVoice, openPrivacy,
}) {
  const onToggleMic = () => {
    // A returning landing: the mic is an entry, and with voice declined it turns voice on as it enters (like the widget).
    if (enabled && landing.isWaiting()) {
      landing.tap(!needsDecision && !hasAudioConsentRef.current ? enterWithVoice : undefined);
      return;
    }
    if (!hasAudioConsentRef.current) { (enabled ? enableVoice : openPrivacy)(); return; }
    if (!enabled) { setIsMicOn(!isMicOn); return; }
    if (micBlocked.live) { setIsMicOn(false); return; } // mute for this visit
    if (micBlocked.blocked) micBlocked.markRetry(); // only a retry of a refused start counts toward "hard blocked"
    if (isMicOn) startMicrophone(); else setIsMicOn(true);
  };
  return {
    onToggleMic,
    micShownOn: enabled ? micBlocked.live : isMicOn,
    micRecording: enabled ? micBlocked.live : (isMicOn && hasAudioConsent),
  };
}
